import api from '../utils/api'

export const createBoarding = async (requestId, boardingData) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            requestId: requestId,
            obsEmbarque: boardingData.obsEmbarque,
            transportadora: boardingData.transportadora,
            tipoVeiculo: boardingData.tipoVeiculo,
            placaVeiculo: boardingData.placaVeiculo,
            nomeMotorista: boardingData.nomeMotorista,
            rgMotorista: boardingData.rgMotorista
        }

        const data = await api.post('/boarding/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        return null        
    }

}

export const getBoardingByRequest = async (idRequest) =>{

    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/boarding/${idRequest}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        return null        
    }
}

const BoardingService = {
    createBoarding,
    getBoardingByRequest
}

export default BoardingService